import PropTypes from 'prop-types';
import React from 'react';

import { EqSizes } from '../../../../constants/Eq';
import { createBEM } from '../../../../lib/utils/css';
import Eq from '../../../lib/Eq/Eq';

import './RowItemEq.scss';

const RowItemEq = React.memo(({ color, isPlaying, isInteractive, isRowSmall, isLarge }) => {
  if (isInteractive) return null;

  const classNames = createBEM('RowItemEq', {
    small: isRowSmall,
    large: isLarge,
  });

  return (
    <div className={classNames}>
      <Eq color={color} isPlaying={isPlaying} size={EqSizes.XSMALL} />
    </div>
  );
});

RowItemEq.propTypes = {
  color: PropTypes.string.isRequired,
  isPlaying: PropTypes.bool.isRequired,
  isInteractive: PropTypes.bool.isRequired,
  isRowSmall: PropTypes.bool.isRequired,
  isLarge: PropTypes.bool,
};

export default RowItemEq;
